import classNames from 'classnames';
import { LayoutProps } from '../LayoutProps';
import { LeftSide } from '../ThreeSideLayout/LeftSide';

import styles from './TwoSideLayout.module.css';

export type TwoSideLayoutProps = LayoutProps & {
    qrSide?: 'left' | 'right';
};

/**
 * Three side layout
 */
export function TwoSideLayout({ qrSide = 'left', children }: TwoSideLayoutProps) {
    return (
        <div className={classNames(styles.container, qrSide === 'right' && styles.reverse)}>
            <div className={styles.leftSide}>
                <LeftSide />
            </div>
            <div className={styles.gameView}>{children}</div>
        </div>
    );
}
